module.exports = __webpack_public_path__ + "img/404.e4301010.gif";